
import { Navbar1 } from 'components/navbars';
import { Footer1, Footer2 } from 'components/footer';
import BackToTop from 'components/BackToTop';

import Hero from './Hero';
import PostContent from './PostContent';
import PostNavigation from './PostNavigation';
import Comments from './Comments';

import { gallery } from '../Career/data';
import { useEffect, useState } from 'react';
import { Post2 } from 'components/blog';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getAllBlogs, getBlogsBySlug } from 'helpers/api/BlogService';
import { Helmet } from 'react-helmet-async';

type Props = {
    blogData?: Post2;
};


const BlogPost = ({ blogData: initialData }: Props) => {
    const { title } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const formattedTitle = title ? title.replace(/-/g, ' ') : "";
    const allDetails = location.state as { id?: number } | null;
    const [blogData, setBlogData] = useState<Post2 | null>(initialData || null);
    const { slug } = useParams();



    // useEffect(() => {
    //     const fetchBlog = async () => {
    //         try {
    //             let response;

    //             if (allDetails?.id) {
    //                 // fetch by id
    //                 response = await getBlogById(allDetails.id);
    //             } else if (title) {
    //                 // fetch by slug
    //                 console.log('title ++', title)
    //             }

    //             if (response?.success && response.result) {
    //                 const blog: Post2 = {
    //                     id: response.result.id,
    //                     title: response.result.blogTitle,
    //                     longDescription: response.result.longDescription,
    //                     image: response.result.blogImage,
    //                     tag: response.result.blogTags,
    //                     createdOn: response.result.createdOn,
    //                     status: response.result.status,
    //                     blogTitle: response.result.blogTitle,
    //                     shortDescription: response.result.shortDescription,
    //                     blogTags: response.result.blogTags,
    //                     blogImage: response.result.blogImage,
    //                     metaKeywords: response.result.metaKeywords
    //                 };

    //                 setBlogData(blog);
    //             }
    //         } catch (error) {
    //             console.error("Failed to fetch blog:", error);
    //         }
    //     };

    //     fetchBlog();
    // }, [allDetails?.id, title]);

    console.log('allDetails ++', allDetails)

    // useEffect(() => {
    //     const fetchBlog = async () => {
    //         try {
    //             let response;
    //             if (slug) {
    //                 response = await getBlogsBySlug(slug);
    //             }
    //             if (response?.success && response.result) {
    //                 const blog: Post2 = {
    //                     id: response.result.id,
    //                     title: response.result.blogTitle,
    //                     longDescription: response.result.longDescription,
    //                     image: response.result.blogImage,
    //                     tag: response.result.blogTags,
    //                     createdOn: response.result.createdOn,
    //                     status: response.result.status,
    //                     blogTitle: response.result.blogTitle,
    //                     shortDescription: response.result.shortDescription,
    //                     blogTags: response.result.blogTags,
    //                     blogImage: response.result.blogImage,
    //                     metaKeywords: response.result.metaKeywords,
    //                     slug: response.result.slug
    //                 };
    //                 setBlogData(blog);
    //             }
    //         } catch (error) {
    //             console.error("Failed to fetch blog:", error);
    //         }
    //     };

    //     fetchBlog();
    // }, [allDetails?.id, slug]);

    useEffect(() => {
        if (initialData) return; // ✅ skip API call

        const fetchBlog = async () => {
            try {
                if (slug) {
                    const response = await getBlogsBySlug(slug);

                    if (response?.success && response.result) {
                        const blog: Post2 = {
                            id: response.result.id,
                            title: response.result.blogTitle,
                            longDescription: response.result.longDescription,
                            image: response.result.blogImage,
                            tag: response.result.blogTags,
                            createdOn: response.result.createdOn,
                            status: response.result.status,
                            blogTitle: response.result.blogTitle,
                            shortDescription: response.result.shortDescription,
                            blogTags: response.result.blogTags,
                            blogImage: response.result.blogImage,
                            metaKeywords: response.result.metaKeywords,
                            slug: response.result.slug
                        };

                        setBlogData(blog);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch blog:", error);
            }
        };

        fetchBlog();
    }, [slug, initialData]);

    return (
        <>
            {/* {blogData && ( */}
            <Helmet>
                <title>{`${blogData?.title} | Sales Trackify CRM & Sales Management`}</title>
                <meta
                    property="og:description"
                    content={blogData?.shortDescription}
                />
                <meta
                    name="description"
                    content={blogData?.shortDescription}
                />

                <meta
                    name="keywords"
                    content={blogData?.metaKeywords || blogData?.blogTags}
                />

                <meta property="og:title" content={blogData?.title} />

                <meta property="og:image" content={blogData?.blogImage} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={blogData?.title} />
                <meta
                    name="twitter:description"
                    content={blogData?.shortDescription}
                />
                <meta name="twitter:image" content={blogData?.blogImage} />
            </Helmet>
            {/* )} */}
            <div>
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-light zindex-10 shadow"
                    buttonClass="btn-outline-secondary btn-sm"
                />
                <Hero post={blogData} />
            </div>

            <PostContent gallery={gallery} post={blogData} />

            <Footer1 />

            <BackToTop />
        </>
    );
};

export default BlogPost;
